import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Inquiry sent — JARE will get back to you soon");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send your inquiry. Please email directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="glass rounded-3xl p-7 md:p-9" data-testid="contact-form">
      <p className="eyebrow mb-6">Project Inquiry</p>
      <div className="space-y-4">
        <input
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Your name"
          className="input-glass"
          data-testid="contact-name-input"
        />
        <input
          type="email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="Your email"
          className="input-glass"
          data-testid="contact-email-input"
        />
        <textarea
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          placeholder="Tell me about your project"
          rows={5}
          className="input-glass resize-none"
          data-testid="contact-message-input"
        />
        <button
          type="submit"
          disabled={sending}
          className="btn-primary w-full disabled:opacity-50"
          data-testid="contact-submit-button"
        >
          {sending ? "Sending…" : "Send Inquiry"}
        </button>
      </div>
    </form>
  );
}
